import type { Node, NodeProps } from '@xyflow/react';
import { DocumentCheckIcon } from '@heroicons/react/24/outline';
import { Badge } from '../../../catalyst/badge';
import { nodeLabel } from '../graphModel';
import { chevronProps, type FlowNodeData } from '../useGraphLayout';
import { KIND_PALETTE } from '../kindPalette';
import { directiveBadge, taskBadge } from '../taskSchedule';
import { FootLine } from './FootLine';
import { NodeShell } from './NodeShell';

export function ReferenceNode({ data }: NodeProps<Node<FlowNodeData>>) {
  if (data.node.kind !== 'reference') return null;
  const { refKind, number, authority, title } = data.node;
  const status = taskBadge(data.node) ?? directiveBadge(data.node);
  return (
    <NodeShell
      icon={DocumentCheckIcon}
      iconClassName="text-amber-600 dark:text-amber-400"
      compactClassName={KIND_PALETTE.reference.compact}
      label={nodeLabel(data.node)}
      selected={data.selected}
      focused={data.focused}
      {...chevronProps(data)}
      className="w-50"
    >
      <div className="flex flex-wrap items-center gap-x-1 gap-y-1">
        <span className="max-w-full shrink-0 truncate text-sm font-medium">
          {refKind.toUpperCase()} {number}
        </span>
        {authority && (
          <Badge color="zinc" data-detail>
            {authority}
          </Badge>
        )}
        {status && (
          <Badge color={status.color} className="whitespace-nowrap" data-detail>
            {status.label}
          </Badge>
        )}
      </div>
      <FootLine text={title} mentions={data.mentions} />
    </NodeShell>
  );
}
